module.exports = {
  // LoginMode: 10:使用資料庫使用者名稱, 20:商業獅 SSO
  loginMode: 20,
  // 設定此應用程式是否為 IIS 下的 sub application
  isIISSubApp: true,
  IISSubAppRoute: 'survey',
  developPort: 44313
}
